import React, { useEffect, useContext } from 'react';
import emulatorSetVolume from '../emulator/setVolume';
import GbaContext from './gba-context';
import { makeLogger } from '../emulator/logs';
const defaultWidth = 240;
const defaultHeight = 160;
const ReactGbaJs = ({ onFpsReported, volume = 0, watchLogLevels = { error: true }, onLogReceived = () => { }, scale = 1, }) => {
    const { gba, clearGbaInstance, setFpsCallback, canvasRef, } = useContext(GbaContext);
    useEffect(() => {
        setFpsCallback(onFpsReported);
    }, [onFpsReported, setFpsCallback]);
    useEffect(() => {
        gba === null || gba === void 0 ? void 0 : gba.setLogger(makeLogger(gba, watchLogLevels, onLogReceived));
    }, [gba, JSON.stringify(watchLogLevels), onLogReceived]);
    useEffect(() => () => clearGbaInstance(), []);
    useEffect(() => {
        if (gba === undefined) {
            return;
        }
        emulatorSetVolume(gba, volume);
    }, [gba, volume]);
    return (React.createElement("div", { style: {
            width: defaultWidth * scale,
            height: defaultHeight * scale,
        } },
        React.createElement("canvas", { ref: canvasRef, width: defaultWidth, height: defaultHeight, style: {
                transform: `scale(${scale})`,
                transformOrigin: 'left top',
            } })));
};
export default ReactGbaJs;
